import { withStyles } from '@material-ui/styles';
import flowRight from 'lodash.flowright';
import React, { useMemo, useState } from 'react';
import styles from '../styles/grouped';
import { connect } from 'react-redux';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@material-ui/core';
import clsx from 'clsx';

import Table from './Table';
import { isDefined } from '../../../utils/isDefined';
import NestedGroup from './NestedGroup';
import {
  countQuantity,
  findSkuTranslation
} from '../actions/customSearchActions';
import Optional from '../../../utils/optional';
import groupBy from 'lodash.groupby';

const Grouped = ({ data, groupedBy, classes, level = 0, lang }) => {
  const [expanded, setExpanded] = useState([]);
  const groupedData = useMemo(() => {
    const groupedByLevel = groupBy(data, groupedBy[level].value);

    if (groupedBy[level].value === 'user') {
      if (isDefined(groupedByLevel.null)) {
        const newGroupedByLevel = {
          ...groupedByLevel,
          'No user': groupedByLevel.null
        };
        delete newGroupedByLevel.null;

        return newGroupedByLevel;
      }
    }

    return groupedByLevel;
  }, [data, groupedBy, level]);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(prev =>
      isExpanded ? [...prev, panel] : prev.filter(key => key !== panel)
    );
  };

  return (
    <div>
      {Object.keys(groupedData)
        .sort()
        .map(el => {
          return (
            <Accordion
              className={classes.accordion}
              key={el}
              expanded={expanded.includes(el)}
              onChange={handleChange(el)}
            >
              <AccordionSummary
                classes={{ content: classes.accordionSummary }}
                style={{
                  backgroundColor: 'lightgrey',
                  filter: `brightness(${level === 0 ? 1 : 1 + level * 0.05})`,
                  borderRadius: '5px'
                }}
                expandIcon={
                  <i
                    className={clsx('fa fa-angle-down', classes.showMoreIcon)}
                  />
                }
              >
                {groupedBy[level].value === 'sku' ? (
                  <div className={classes.skuContainer}>
                    <div>
                      {findSkuTranslation({
                        rowData: groupedData[el][0],
                        lang
                      })}
                    </div>
                    <div className={classes.sku}>{el}</div>
                  </div>
                ) : (
                  el
                )}
                <div className={classes.quantity}>
                  <div>{`${groupedData[el].length} subscription${
                    groupedData[el].length > 1 ? 's' : ''
                  }`}</div>
                  <div>{`Quantity : ${countQuantity(groupedData[el])}`}</div>
                </div>
              </AccordionSummary>
              {expanded.includes(el) && (
                <AccordionDetails
                  classes={{ root: classes.accordionDetailsRoot }}
                >
                  {isDefined(groupedBy[level + 1]) ? (
                    <NestedGroup
                      data={groupedData[el]}
                      level={level + 1}
                      groupedBy={groupedBy}
                    />
                  ) : (
                    <Table data={groupedData[el]} />
                  )}
                </AccordionDetails>
              )}
            </Accordion>
          );
        })}
    </div>
  );
};

const mapStatesToProps = ({ subscriptionsImproved, auth }) => {
  return {
    groupedBy: subscriptionsImproved.filters.groupedBy,
    lang: Optional(auth.lang).or('default')
  };
};

export default flowRight(
  connect(mapStatesToProps),
  withStyles(styles)
)(Grouped);
